import IframeActivity from "./IframeActivity";

export default function HiddenArguments() {
    return (
        <IframeActivity
            src="/activities/hidden-arguments/index.html"
            title="Hidden Arguments"
        />
    );
}